import {
  FeedbackStatus,
  ReportStage,
} from 'donor/portal/pages/FeedbackDashboard/api';
import {
  AllocationState,
  InvestmentStatus,
  Report,
  Task,
} from '../Tasks/api';
import { ApolloClient, gql } from 'apollo-boost';

const baseQuery = `
  edges {
    node {
      id
      dbId
      message
      donation
      status
      totalAllocated
      unallocatedAmount
      allocationState
      recipient
      cashAmount
      goodsAmount
      servicesAmount
      volunteerismAmount
      invitation {
        edges {
          node {
            email
            firstName
            lastName
            createdAt
            updatedAt
            notificationDt
          }
        }
      }
      portfolio {
        name
        year
        funder {
          name
        }
      }
      allocations {
        edges {
          node {
            tasks {
              edges {
                node {
                  taskId
                  dueDate
                  invitation {
                    createdAt
                    investment {
                      dbId
                      donation
                      totalAllocated
                      unallocatedAmount
                      allocationState
                      programNameByDonor
                      portfolio {
                        year
                        isImpactSnapshot
                        funder {
                          name
                        }
                        relationshipManager {
                          firstName
                          lastName
                          email
                        }
                      }
                    }
                  }
                  allocation {
                    investment {
                      dbId
                      donation
                      totalAllocated
                      unallocatedAmount
                      allocationState
                      programNameByDonor
                      portfolio {
                        year
                        isImpactSnapshot
                        funder {
                          name
                        }
                        relationshipManager {
                          firstName
                          lastName
                          email
                        }
                      }
                    }
                  }
                }
              }
            }
            dbId
            amount
            report {
              dbId
              status
              stage
              totalDonations
              endDate
              programId
              year
              program {
                id
                name
                managerId
                manager {
                  firstName
                  lastName
                  email
                }
              }
            }
          }
        }
      }
    }
  }
`;

const query = gql`
  query {
    allInvestments {
      ${baseQuery}
    }
  }
`;

const investmentById = gql`
  query allInvestments($investmentId: ID!) {
    allInvestments(filters: {id: $investmentId}) {
      ${baseQuery}
    }
  }
`;

export interface DonationsAllocation {
  dbId: number;
  amount: number;
  tasks: Task[];
  report?: Report & {
    dbId: number;
    stage: ReportStage;
    status: FeedbackStatus;
    totalDonations: number;
  };
}

export interface Investment {
  id: string;
  recipient: string;
  dbId: number;
  donation: number;
  status?: InvestmentStatus;
  totalAllocated?: number;
  // Server-owned remainder, the source of truth for partial allocations.
  unallocatedAmount?: number;
  allocationState?: AllocationState;
  cashAmount: number;
  goodsAmount: number;
  servicesAmount: number;
  volunteerismAmount: number;
  message: string;
  portfolio: {
    funder: {
      name: string;
    };
    name: string;
    year: string;
  } | null;
  allocations?: DonationsAllocation[];
  invitation: {
    email: string;
    createdAt: string;
    updatedAt: string;
    firstName: string;
    lastName: string;
    notificationDt: null;
  }[];
}

export interface Donations {
  allInvestments: Investment[];
}

export const getDonationsApi = (client: ApolloClient<object>) => {
  return client.query<Donations>({
    query,
    fetchPolicy: 'network-only',
  });
};

export const getDonationsById = (
  client: ApolloClient<object>,
  investmentId: number | string,
) => {
  return client.query<Donations>({
    query: investmentById,
    variables: {
      investmentId,
    },
    fetchPolicy: 'network-only',
  });
};
